import { isStandalone } from '@/lib/platform'

/**
 * Shown when the app is opened in a browser tab instead of the installed
 * home-screen icon. In that mode IndexedDB is a separate, ITP-evicting partition,
 * so the ledger here is not the protected one.
 */
export function StandaloneBanner() {
  if (isStandalone()) return null
  return (
    <div
      role="alert"
      className="bg-amber-500/15 text-amber-200 text-xs px-3 py-2 border-b border-amber-500/30"
    >
      Running in a browser tab. For offline safety and to keep your records, install
      and open Mobile Trading Pro from the Home Screen (Share → Add to Home Screen).
    </div>
  )
}
